import { ICustomSectionDefinition } from "services/custom-section";

import { IInboxMessage, INormalizedInboxMessage } from "./inbox-message";
import { IInboxMessageDenormalizer } from "./inbox-message-denormalizer";
import { InboxMessageTitles } from "./inbox-message-titles";

export interface ICustomerDetailsSectionMessage extends IInboxMessage {
  readonly title: InboxMessageTitles.CustomerDetailsSection;
  readonly data: ICustomSectionDefinition;
}

export function createCustomerDetailsSectionMessage(
  pluginId: string,
  section: ICustomSectionDefinition
): ICustomerDetailsSectionMessage {
  return { title: InboxMessageTitles.CustomerDetailsSection, pluginId, data: section };
}

export const CustomerDetailsSectionMessageDenormalizer: IInboxMessageDenormalizer<ICustomerDetailsSectionMessage> = {
  createMessage: (message: INormalizedInboxMessage) =>
    createCustomerDetailsSectionMessage(message.plugin_id, message.data),
  messageTitle: InboxMessageTitles.CustomerDetailsSection,
};
